import { setLocale } from '~/lib/DateTime.js';
import { useEffect } from 'react';
import { useSetCurrency } from '~/lib/CurrencyHelpers.js';

export function useSetLocale(businessData) {
    useSetCurrency(businessData?.currency);
    useEffect(() => {
        if (businessData) {
            setLocale(businessData);
        }
    }, [businessData]);
}
